// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"216":"5cf5928c93304e85","897":"6c81b50b09e77774"}[chunkId] + ".js";
};